import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { MembranePrediction } from "constants/constantStrings";

import { MEMBRANE_PREDICTION_TABLE_COLUMN } from "pages/Analytics/AnalyticsPredictionTable/CIPPredictionTable.config";
import AgTable from "components/AgTable";
import DupontDialog from "components/DupontDialog";
import TextWithRightArrow from "components/TextWithRightArrow";

import { MembranePredictionsData } from "./MembranePredictionData";
import { CIT3PopoverMessage, DpPopoverMessage, PT2PopoverMessage } from "./MembranePopoverMessages";

import "../index.scss";

const MembranePredictionCard = ({ value, customClass }) => {
  const [membranePredictionData, setMembranePredictionData] = useState(null);
  const [cit3DialogOpen, setCIT3DialogOpen] = useState(false);
  const [pt2DialogOpen, setPT2DialogOpen] = useState(false);
  const [dpDialogOpen, setDPDialogOpen] = useState(false);
  const { isAdmin } = useSelector(state => state.user);
  useEffect(() => {
    if (value) setMembranePredictionData(MembranePredictionsData(value));
  }, [value]);

  return (
    <div className={`membrane-card  ${customClass} `}>
      <div className="flex-between marginBtm10 ">
        <div className="fullWidth">
          <div className="d-flex ">
            <h1>{MembranePrediction.membranePrediction}</h1>
          </div>
          {/* {<h4>{MembranePrediction.membranePredictionMethod}</h4>} */}
          <div className="table-Container margin-top-20 marginBtm20">
            {membranePredictionData && (
              <AgTable
                rowData={membranePredictionData}
                columnDefs={MEMBRANE_PREDICTION_TABLE_COLUMN("membrane", isAdmin)}
                rowHeight="auto"
                customTableClass="ag-theme-readOnly-react table-header"
              />
            )}
          </div>
          <h4>{MembranePrediction.membranePredictionNote}</h4>
          <div className="d-flex">
            {value["CIT3_RMNG_months_BF_MemRep"] < 6 && (
              <div className="marginTop10">
                <TextWithRightArrow
                  text={MembranePrediction.conductivityMainMessageTitle}
                  fontStyle={"clickable-green-text"}
                  onClick={() => setCIT3DialogOpen(true)}
                />
                <DupontDialog
                  open={cit3DialogOpen}
                  onClose={() => setCIT3DialogOpen(false)}
                  title={MembranePrediction.conductivityMainMessageTitle}
                  type="primary"
                >
                  <div className="message-dialog">
                    <div className="description marginBtm10">
                      <span className="underline">{MembranePrediction.mainMessageTitle1}</span>
                      <span className="descriptionBold">&nbsp;</span>
                      {MembranePrediction.conductivityMainMessage1} {value["CIT3_RMNG_months_BF_MemRep"]}{" "}
                      {MembranePrediction.conductivityMainMessage12}
                    </div>
                    <div className="description marginBtm10">
                      <span className="underline ">{MembranePrediction.mainMessageTitle2}</span>
                      <span className="descriptionBold">&nbsp;</span>
                      {MembranePrediction.conductivityMainMessage2}
                    </div>
                    <div className="description marginBtm10">
                      <span className="underline ">{MembranePrediction.mainMessageTitle3}</span>
                      <span className="descriptionBold">&nbsp;</span>
                      {MembranePrediction.conductivityMainMessage3}
                    </div>
                    <CIT3PopoverMessage />
                  </div>
                </DupontDialog>
              </div>
            )}
            {value["PT2_RMNG_months_BF_MemRep"] < 6 && (
              <div className="marginTop10">
                <TextWithRightArrow
                  text={MembranePrediction.pt2MainMessageTitle}
                  fontStyle={"clickable-green-text"}
                  onClick={() => setPT2DialogOpen(true)}
                />
                <DupontDialog
                  open={pt2DialogOpen}
                  onClose={() => setPT2DialogOpen(false)}
                  title={MembranePrediction.pt2MainMessageTitle}
                  type="primary"
                >
                  <div className="message-dialog">
                    <div className="description marginBtm10">
                      <span className="underline">{MembranePrediction.mainMessageTitle1}</span>
                      <span className="descriptionBold">&nbsp;</span>
                      {MembranePrediction.pt2MainMessage1} {value["PT2_RMNG_months_BF_MemRep"]} {MembranePrediction.pt2MainMessage12}
                    </div>
                    <div className="description marginBtm10">
                      <span className="underline ">{MembranePrediction.mainMessageTitle2}</span>
                      <span className="descriptionBold">&nbsp;</span>
                      {MembranePrediction.pt2MainMessage2}
                    </div>
                    <div className="description marginBtm10">
                      <span className="underline ">{MembranePrediction.mainMessageTitle3}</span>
                      <span className="descriptionBold">&nbsp;</span>
                      {MembranePrediction.pt2MainMessage3}
                    </div>
                    <PT2PopoverMessage />
                  </div>
                </DupontDialog>
              </div>
            )}
            {value["DP_RMNG_months_BF_MemRep"] < 6 && (
              <div className="marginTop10">
                <TextWithRightArrow
                  text={MembranePrediction.dpMainMessageTitle}
                  fontStyle={"clickable-green-text"}
                  onClick={() => setDPDialogOpen(true)}
                />
                <DupontDialog open={dpDialogOpen} onClose={() => setDPDialogOpen(false)} title={MembranePrediction.dpMainMessageTitle} type="primary">
                  <div className="message-dialog">
                    <div className="description marginBtm10">
                      <span className="underline">{MembranePrediction.mainMessageTitle1}</span>
                      <span className="descriptionBold">&nbsp;</span>
                      {MembranePrediction.dpMainMessage1} {value["DP_RMNG_months_BF_MemRep"]} {MembranePrediction.dpMainMessage12}
                    </div>
                    <div className="description marginBtm10">
                      <span className="underline ">{MembranePrediction.mainMessageTitle2}</span>
                      <span className="descriptionBold">&nbsp;</span>
                      {MembranePrediction.dpMainMessage2}
                    </div>
                    <div className="description marginBtm10">
                      <span className="underline ">{MembranePrediction.mainMessageTitle3}</span>
                      <span className="descriptionBold">&nbsp;</span>
                      {MembranePrediction.dpMainMessage3}
                    </div>
                    <DpPopoverMessage />
                  </div>
                </DupontDialog>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default MembranePredictionCard;
